'use client';
import React, { useRef } from 'react';
import ReactLenis from 'lenis/react';

function LenisInit({ children }: { children: React.ReactNode })
{
  const lenisRef = useRef<any>(undefined);

  return (
    <ReactLenis root options={ { lerp: 0.1, duration: 1.5, smoothWheel: true } } ref={ lenisRef }>
      { children }
    </ReactLenis>
  );
}

export default LenisInit;
